import { render, staticRenderFns } from "./My-4-Sending.vue?vue&type=template&id=55b577da&"
import script from "./My-4-Sending.vue?vue&type=script&lang=js&"
export * from "./My-4-Sending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports